import {useLayoutEffect} from 'react';
import { HeaderComponent } from './component/HeaderComponent';
import { MainComponent } from './component/MainComponent';
import './App.css';
import './dashboard.css';
import './presentation.css';
function App() {
  useLayoutEffect(()=>{
    const root=document.getElementById('root');
    const tablet=window.matchMedia('(min-width:768px) and (max-width:1033px)');
    const fit=()=>{
      // clientWidth follows the CSS viewport, not overflowing page content.
      const width=document.documentElement.clientWidth;
      root.style.setProperty('--tablet-scale',tablet.matches?String(width/1034):'1');
      root.style.removeProperty('zoom');
      root.style.removeProperty('width');
    };
    fit();
    window.addEventListener('resize',fit);
    tablet.addEventListener('change',fit);
    return ()=>{window.removeEventListener('resize',fit);tablet.removeEventListener('change',fit);root.style.removeProperty('--tablet-scale');};
  },[]);
  return <><a className="skip-link" href="#main-content">跳到主要内容</a><div className="site-header-bar"><div className="app-shell"><HeaderComponent/></div></div><div className="app-shell"><MainComponent/><footer className="site-footer"><span>KKAA · 开奖数据与统计分析</span><span>历史统计仅供参考，随机开奖无法保证预测准确。</span></footer></div></>;
}
export default App;
